import { formatNeedsReviewReason } from './needsReviewReason';

/**
 * Build the plain-text block that "Copy Decision" writes to the clipboard.
 *
 * Kept pure (no DOM / clipboard) so the exact copied text is unit-testable.
 * Includes a REASON line only when the agent supplied needs_review_reason —
 * MDF escalations can have empty key_findings, so the reason is often the only
 * explanation and must not be dropped from the copy. When the agent also
 * supplied a human-readable needs_review_detail (why it needs review + what to
 * confirm), that follows on its own line so the reviewer copies the full cause.
 *
 * @param {object} summary approval_summary from the request
 * @param {string} [dateStr] pre-formatted date (injected so callers control
 *   formatting and tests stay deterministic)
 * @returns {string}
 */
export function buildDecisionClipboardText(summary, dateStr) {
  const s = summary || {};
  const decision = s.decision || 'PENDING';
  const keyFindings = s.key_findings || [];
  const reason = formatNeedsReviewReason(s.needs_review_reason);
  // Collapse any embedded newlines so agent free-text stays on its own single
  // labeled line and can't fracture the copied block (batpur review).
  const detail = (s.needs_review_detail || '').replace(/\r?\n/g, ' ').trim();
  // The reject counterpart of needs_review_detail: a plain-English "why this
  // was rejected" sentence, so a rejection copies its explanation (not just the
  // policy code) the same way an escalation copies needs_review_detail.
  const rejectDetail = (s.reject_detail || '').replace(/\r?\n/g, ' ').trim();
  const reasonLine = reason ? `\nREASON: ${reason}` : '';
  const detailLine = detail ? `\nWHY THIS NEEDS REVIEW: ${detail}` : '';
  const rejectLine = rejectDetail ? `\nWHY THIS WAS REJECTED: ${rejectDetail}` : '';
  const explanationBlock = reasonLine || detailLine || rejectLine
    ? `${reasonLine}${detailLine}${rejectLine}\n` : '';

  return `
CHRONOS VALIDATION DECISION

DECISION: ${decision}
${explanationBlock}
KEY FINDINGS:
${keyFindings.map((finding) => `• ${finding}`).join('\n')}

Generated by Chronos MAP Validation Platform
Date: ${dateStr || ''}
  `.trim();
}
